import { Bytecode } from './../Bytecode';
var BytecodeName = Bytecode;
var DEFAULT_STACK_INDEX = -1024;
var Instruction = /** @class */ (function () {
    function Instruction(position, name, params, delta, deltaScope, terminal, refs) {
        if (params === void 0) { params = []; }
        if (delta === void 0) { delta = 0; }
        if (deltaScope === void 0) { deltaScope = 0; }
        if (terminal === void 0) { terminal = false; }
        if (refs === void 0) { refs = []; }
        this.position = position;
        this.name = name;
        this.params = params;
        this.delta = delta;
        this.deltaScope = deltaScope;
        this.terminal = terminal;
        this.refs = refs;
        this.stack = DEFAULT_STACK_INDEX;
        this.scope = DEFAULT_STACK_INDEX;
        this.catchStart = false;
        this.catchEnd = false;
        this.returnTypeId = -1; // void
        this.childs = [];
    }
    Instruction.prototype.toString = function () {
        return "Instruction(" + this.position + ", " + BytecodeName[this.name] + " (" + this.name + "), [" + this.params + "], " + this.stack + " -> " + (this.stack + this.delta) + ", " + this.scope + " -> " + (this.scope + this.deltaScope) + ", " + this.terminal + ", [" + this.refs + "])";
    };
    return Instruction;
}());
export { Instruction };
/**
 * Propogade stack for calculation real stack size for every instruction
 */
export function propagateStack(position, stack, q) {
    var v = stack;
    var l = q.length;
    var minStack = stack;
    for (var i = 0; i < l; i++) {
        if (q[i].position >= position) {
            if (q[i].stack >= 0)
                return minStack;
            q[i].stack = v;
            v += q[i].delta;
            if (v < minStack)
                minStack = v;
            for (var j = 0; j < q[i].refs.length; j++) {
                var s = propagateStack(q[i].refs[j], v, q);
                if (s < minStack)
                    minStack = s;
            }
            if (q[i].terminal)
                return minStack;
        }
    }
    return minStack;
}
/**
 * Like as propogadeStack, only for scope
 */
export function propagateScope(position, scope, q) {
    var v = scope;
    var l = q.length;
    for (var i = 0; i < l; i++) {
        if (q[i].position >= position) {
            if (q[i].scope >= 0)
                return;
            q[i].scope = v;
            v += q[i].deltaScope;
            for (var j = 0; j < q[i].refs.length; j++) {
                propagateScope(q[i].refs[j], v, q);
            }
            if (q[i].terminal)
                return;
        }
    }
}
export function propogateTree(q, jumps) {
    var branches = {};
    var condNodes = [];
    branches[0] = 0;
    var l = q.length;
    for (var i = 1; i < l; i++) {
        var inst = q[i];
        if (jumps.indexOf(inst.position) > -1) {
            branches[inst.position] = i;
        }
        if (inst.name >= Bytecode.IFNLT
            && inst.name <= Bytecode.LOOKUPSWITCH) {
            condNodes.push(inst);
        }
    }
    for (var _i = 0, condNodes_1 = condNodes; _i < condNodes_1.length; _i++) {
        var c = condNodes_1[_i];
        if (c.name === Bytecode.LOOKUPSWITCH) {
            var params = c.params;
            c.childs = [];
            for (var i = 0; i < params.length - 1; i++) {
                c.childs.push(branches[i]);
            }
            continue;
        }
        if (c.name === Bytecode.JUMP) {
            c.childs = [branches[c.params[0]]];
            continue;
        }
        c.childs.push(branches[c.params[0]]);
    }
}
/**
 * Affilate instruction set from method info
 * @param methodInfo
 */
export function affilate(methodInfo) {
    var abc = methodInfo.abc;
    var body = methodInfo.getBody();
    var code = body.code;
    var q = [];
    var type = 0;
    var lastType = 0;
    var _loop_1 = function (i) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        var u30 = function () {
            var u = code[i++];
            if (u & 0x80) {
                u = u & 0x7f | code[i++] << 7;
                if (u & 0x4000) {
                    u = u & 0x3fff | code[i++] << 14;
                    if (u & 0x200000) {
                        u = u & 0x1fffff | code[i++] << 21;
                        if (u & 0x10000000) {
                            u = u & 0x0fffffff | code[i++] << 28;
                            u = u & 0xffffffff;
                        }
                    }
                }
            }
            return u >>> 0;
        };
        var mn = function () {
            var index = u30();
            var name = abc.getMultiname(index);
            if (name.isRuntimeName() || name.isRuntimeNamespace())
                return [index, 256, name.isRuntimeName() && name.isRuntimeNamespace() ? -2 : -1];
            return [index, 0, 0];
        };
        var s24 = function () {
            var u = code[i++] | (code[i++] << 8) | (code[i++] << 16);
            return (u << 8) >> 8;
        };
        var s8 = function () {
            var u = code[i++];
            return (u << 24) >> 24;
        };
        var oldi = i;
        var z = code[i++];
        var ins = void 0;
        switch (z) {
            case Bytecode.LABEL:
                ins = (new Instruction(oldi, z));
                break;
            case Bytecode.DXNSLATE:
                ins = (new Instruction(oldi, z, [0], -1));
                break;
            case Bytecode.DEBUGFILE:
            case Bytecode.DEBUGLINE:
                ins = (new Instruction(oldi, z, [u30()]));
                break;
            case Bytecode.DEBUG:
                ins = (new Instruction(oldi, z, [s8(), u30(), s8(), u30()]));
                break;
            case Bytecode.THROW:
                ins = (new Instruction(oldi, z, [], -1, 0, true));
                break;
            case Bytecode.PUSHSCOPE:
                ins = (new Instruction(oldi, z, [], -1, 1));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.PUSHWITH:
                ins = (new Instruction(oldi, z, [], -1, 1));
                break;
            case Bytecode.POPSCOPE:
                ins = (new Instruction(oldi, z, [], 0, -1));
                break;
            case Bytecode.GETSCOPEOBJECT:
                ins = (new Instruction(oldi, z, [s8()], 1, 0));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.GETGLOBALSCOPE:
                ins = (new Instruction(oldi, z, [], 1));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.GETSLOT:
                ins = (new Instruction(oldi, z, [u30()], 0));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.SETSLOT:
                ins = (new Instruction(oldi, z, [u30()], -2));
                break;
            case Bytecode.NEXTNAME:
                ins = (new Instruction(oldi, z, [], -1));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.NEXTVALUE:
                ins = (new Instruction(oldi, z, [], -1));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.HASNEXT:
                ins = (new Instruction(oldi, z, [], -1));
                ins.returnTypeId = lastType = -2 /* BOOL */;
                break;
            case Bytecode.HASNEXT2:
                ins = (new Instruction(oldi, z, [u30(), u30()], 1));
                ins.returnTypeId = lastType = -2 /* BOOL */;
                break;
            case Bytecode.IN:
                ins = (new Instruction(oldi, z, [], -1));
                ins.returnTypeId = lastType = -2 /* BOOL */;
                break;
            case Bytecode.DUP:
                ins = (new Instruction(oldi, z, [], 1));
                ins.returnTypeId = lastType = type;
                break;
            case Bytecode.POP:
                ins = (new Instruction(oldi, z, [], -1));
                ins.returnTypeId = lastType = type;
                break;
            case Bytecode.SWAP:
                ins = (new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.PUSHTRUE:
                ins = (new Instruction(oldi, z, [], 1));
                ins.returnTypeId = lastType = -2 /* BOOL */;
                break;
            case Bytecode.PUSHFALSE:
                ins = (new Instruction(oldi, z, [], 1));
                ins.returnTypeId = lastType = -2 /* BOOL */;
                break;
            case Bytecode.PUSHBYTE:
                ins = (new Instruction(oldi, z, [s8()], 1));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.PUSHSHORT:
                ins = (new Instruction(oldi, z, [u30() << 16 >> 16], 1));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.PUSHINT:
                ins = (new Instruction(oldi, z, [u30()], 1));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.PUSHUINT:
                ins = (new Instruction(oldi, z, [u30()], 1));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.PUSHDOUBLE:
                ins = (new Instruction(oldi, z, [u30()], 1));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.PUSHNAN:
                ins = (new Instruction(oldi, z, [], 1));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.PUSHNULL:
                ins = (new Instruction(oldi, z, [], 1));
                ins.returnTypeId = lastType = -6 /* NULL */;
                break;
            case Bytecode.PUSHUNDEFINED:
                ins = (new Instruction(oldi, z, [], 1));
                ins.returnTypeId = lastType = -5 /* UNDEF */;
                break;
            case Bytecode.PUSHSTRING:
                ins = (new Instruction(oldi, z, [u30()], 1));
                ins.returnTypeId = lastType = -4 /* STRING */;
                break;
            case Bytecode.IFEQ:
                j = s24();
                ins = (new Instruction(oldi, z, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFNE:
                j = s24();
                ins = (new Instruction(oldi, z, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFSTRICTEQ:
                j = s24();
                ins = (new Instruction(oldi, z, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFSTRICTNE:
                j = s24();
                ins = (new Instruction(oldi, z, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFGT:
            case Bytecode.IFNLE:
                j = s24();
                ins = (new Instruction(oldi, Bytecode.IFGT, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFGE:
            case Bytecode.IFNLT:
                j = s24();
                ins = (new Instruction(oldi, Bytecode.IFGE, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFLT:
            case Bytecode.IFNGE:
                j = s24();
                ins = (new Instruction(oldi, Bytecode.IFLT, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFLE:
            case Bytecode.IFNGT:
                j = s24();
                ins = (new Instruction(oldi, Bytecode.IFLE, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFTRUE:
                j = s24();
                ins = (new Instruction(oldi, z, [i + j], -1, 0, false, [i + j]));
                break;
            case Bytecode.IFFALSE:
                j = s24();
                ins = (new Instruction(oldi, z, [i + j], -1, 0, false, [i + j]));
                break;
            case Bytecode.LOOKUPSWITCH:
                offset = oldi + s24();
                cases = u30();
                table = [offset];
                for (var j_1 = 0; j_1 <= cases; j_1++)
                    table.push(oldi + s24());
                ins = (new Instruction(oldi, z, table, -1, 0, true, table));
                break;
            case Bytecode.JUMP:
                j = s24();
                ins = (new Instruction(oldi, z, [i + j], 0, 0, true, [i + j]));
                break;
            case Bytecode.RETURNVALUE:
                ins = (new Instruction(oldi, z, [], -1, 0, true));
                break;
            case Bytecode.RETURNVOID:
                ins = (new Instruction(oldi, z, [], 0, 0, true));
                break;
            case Bytecode.NOT:
                ins = (new Instruction(oldi, z, [], 0));
                ins.returnTypeId = lastType = -2 /* BOOL */;
                break;
            case Bytecode.BITNOT:
                ins = (new Instruction(oldi, z, [], 0));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.NEGATE:
                ins = (new Instruction(oldi, z, [], 0));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.INCREMENT:
                ins = (new Instruction(oldi, z, [], 0));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.DECREMENT:
                ins = (new Instruction(oldi, z, [], 0));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.INCLOCAL:
            case Bytecode.DECLOCAL:
                ins = (new Instruction(oldi, z, [u30()], 0));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.INCREMENT_I:
            case Bytecode.DECREMENT_I:
                ins = (new Instruction(oldi, z, [], 0));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.INCLOCAL_I:
            case Bytecode.DECLOCAL_I:
                ins = (new Instruction(oldi, z, [u30()], 0));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.NEGATE_I:
                ins = (new Instruction(oldi, z, [], 0));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.ADD_I:
            case Bytecode.SUBTRACT_I:
            case Bytecode.MULTIPLY_I:
            case Bytecode.ADD:
            case Bytecode.SUBTRACT:
            case Bytecode.MULTIPLY:
            case Bytecode.DIVIDE:
            case Bytecode.MODULO:
            case Bytecode.LSHIFT:
            case Bytecode.RSHIFT:
            case Bytecode.URSHIFT:
            case Bytecode.BITAND:
            case Bytecode.BITOR:
            case Bytecode.BITXOR:
                ins = (new Instruction(oldi, z, [], -1));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            case Bytecode.EQUALS:
            case Bytecode.STRICTEQUALS:
            case Bytecode.GREATERTHAN:
            case Bytecode.GREATEREQUALS:
            case Bytecode.LESSTHAN:
            case Bytecode.LESSEQUALS:
                ins = (new Instruction(oldi, z, [], -1));
                ins.returnTypeId = lastType = -2 /* BOOL */;
                break;
            case Bytecode.TYPEOF:
                ins = (new Instruction(oldi, z, [], 0));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.INSTANCEOF:
                ins = (new Instruction(oldi, z, [], -1));
                ins.returnTypeId = lastType = -2 /* BOOL */;
                break;
            case Bytecode.ISTYPE:
                _a = mn(), index = _a[0], dyn = _a[1], d = _a[2];
                ins = (new Instruction(oldi, z, [index], 0 + d));
                ins.returnTypeId = lastType = -2 /* BOOL */;
                break;
            case Bytecode.ISTYPELATE:
                ins = (new Instruction(oldi, z, [], -1));
                ins.returnTypeId = lastType = -2 /* BOOL */;
                break;
            case Bytecode.ASTYPELATE:
                ins = (new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.ASTYPE:
                _b = mn(), index = _b[0], dyn = _b[1], d = _b[2];
                ins = (new Instruction(oldi, z, [index], 0 + d));
                break;
            case Bytecode.CALL:
                argnum = u30();
                ins = (new Instruction(oldi, z, [argnum], -argnum - 1));
                break;
            case Bytecode.CONSTRUCT:
                argnum = u30();
                ins = (new Instruction(oldi, z, [argnum, index], -argnum));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.CALLPROPERTY:
                _c = mn(), index = _c[0], dyn = _c[1], d = _c[2];
                argnum = u30();
                ins = (new Instruction(oldi, z + dyn, [argnum, index], -argnum + d));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.CALLPROPLEX:
                _d = mn(), index = _d[0], dyn = _d[1], d = _d[2];
                argnum = u30();
                ins = (new Instruction(oldi, z + dyn, [argnum, index], -argnum + d));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.CALLPROPVOID:
                _e = mn(), index = _e[0], dyn = _e[1], d = _e[2];
                argnum = u30();
                ins = (new Instruction(oldi, z + dyn, [argnum, index], -(argnum + 1) + d));
                break;
            case Bytecode.APPLYTYPE:
                argnum = u30();
                ins = (new Instruction(oldi, z, [argnum], -argnum));
                ins.returnTypeId = lastType = type;
                break;
            case Bytecode.FINDPROPSTRICT:
                _f = mn(), index = _f[0], dyn = _f[1], d = _f[2];
                ins = (new Instruction(oldi, z + dyn, [index], 1 + d));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.FINDPROPERTY:
                _g = mn(), index = _g[0], dyn = _g[1], d = _g[2];
                ins = (new Instruction(oldi, z + dyn, [index], 1 + d));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.NEWFUNCTION:
                ins = (new Instruction(oldi, z, [u30()], 1));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.NEWCLASS:
                ins = (new Instruction(oldi, z, [u30()], 0));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.GETDESCENDANTS:
                ins = (new Instruction(oldi, z, [u30()], 0));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.NEWARRAY:
                argnum = u30();
                ins = (new Instruction(oldi, z, [argnum], -argnum + 1));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.NEWOBJECT:
                argnum = u30();
                ins = (new Instruction(oldi, z, [argnum], -2 * argnum + 1));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.NEWACTIVATION:
                ins = (new Instruction(oldi, z, [], 1));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.NEWCATCH:
                ins = (new Instruction(oldi, z, [u30()], 1));
                break;
            case Bytecode.CONSTRUCTSUPER:
                argnum = u30();
                ins = (new Instruction(oldi, z, [argnum], -(argnum + 1)));
                break;
            case Bytecode.CALLSUPER:
                _h = mn(), index = _h[0], dyn = _h[1], d = _h[2];
                argnum = u30();
                ins = (new Instruction(oldi, z + dyn, [argnum, index], -argnum + d));
                break;
            case Bytecode.CALLSUPERVOID:
                _j = mn(), index = _j[0], dyn = _j[1], d = _j[2];
                argnum = u30();
                ins = (new Instruction(oldi, z + dyn, [argnum, index], -(argnum + 1) + d));
                break;
            case Bytecode.CONSTRUCTPROP:
                _k = mn(), index = _k[0], dyn = _k[1], d = _k[2];
                argnum = u30();
                ins = (new Instruction(oldi, z + dyn, [argnum, index], -argnum + d));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.GETPROPERTY:
                _l = mn(), index = _l[0], dyn = _l[1], d = _l[2];
                ins = (new Instruction(oldi, Bytecode.GETPROPERTY + dyn, [index], 0 + d));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.INITPROPERTY:
            case Bytecode.SETPROPERTY:
                _m = mn(), index = _m[0], dyn = _m[1], d = _m[2];
                ins = (new Instruction(oldi, Bytecode.SETPROPERTY + dyn, [index], -2 + d));
                break;
            case Bytecode.DELETEPROPERTY:
                _o = mn(), index = _o[0], dyn = _o[1], d = _o[2];
                ins = (new Instruction(oldi, z + dyn, [index], 0 + d));
                break;
            case Bytecode.GETSUPER:
                _p = mn(), index = _p[0], dyn = _p[1], d = _p[2];
                ins = (new Instruction(oldi, z + dyn, [index], 0 + d));
                ins.returnTypeId = lastType = ++type;
                break;
            case Bytecode.SETSUPER:
                _q = mn(), index = _q[0], dyn = _q[1], d = _q[2];
                ins = (new Instruction(oldi, z + dyn, [index], -2 + d));
                break;
            case Bytecode.COERCE:
                _r = mn(), index = _r[0], dyn = _r[1], d = _r[2];
                ins = (new Instruction(oldi, z + dyn, [index], 0 + d));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.COERCE_A:
                ins = (new Instruction(oldi, z, [], 0));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.COERCE_S:
                ins = (new Instruction(oldi, z, [], 0));
                ins.returnTypeId = -4 /* STRING */;
                break;
            case Bytecode.ESC_XATTR:
            case Bytecode.ESC_XELEM:
            case Bytecode.CONVERT_I:
            case Bytecode.CONVERT_D:
            case Bytecode.CONVERT_B:
            case Bytecode.CONVERT_U:
            case Bytecode.CONVERT_S:
            case Bytecode.CONVERT_O:
                ins = (new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.CHECKFILTER:
                ins = (new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.GETLOCAL:
                ins = (new Instruction(oldi, Bytecode.GETLOCAL, [u30()], 1));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.GETLOCAL0:
                ins = (new Instruction(oldi, Bytecode.GETLOCAL, [0], 1));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.GETLOCAL1:
                ins = (new Instruction(oldi, Bytecode.GETLOCAL, [1], 1));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.GETLOCAL2:
                ins = (new Instruction(oldi, Bytecode.GETLOCAL, [2], 1));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.GETLOCAL3:
                ins = (new Instruction(oldi, Bytecode.GETLOCAL, [3], 1));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.SETLOCAL:
                ins = (new Instruction(oldi, Bytecode.SETLOCAL, [u30()], -1));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.SETLOCAL0:
                ins = (new Instruction(oldi, Bytecode.SETLOCAL, [0], -1));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.SETLOCAL1:
                ins = (new Instruction(oldi, Bytecode.SETLOCAL, [1], -1));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.SETLOCAL2:
                ins = (new Instruction(oldi, Bytecode.SETLOCAL, [2], -1));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.SETLOCAL3:
                ins = (new Instruction(oldi, Bytecode.SETLOCAL, [3], -1));
                ins.returnTypeId = lastType;
                break;
            case Bytecode.KILL:
                ins = (new Instruction(oldi, z, [u30()], 0));
                break;
            case Bytecode.GETLEX:
                _s = mn(), index = _s[0], dyn = _s[1], d = _s[2];
                ins = (new Instruction(oldi, z + dyn, [index], 1 + d));
                ins.returnTypeId = lastType = ++type;
                break;
            //http://docs.redtamarin.com/0.4.1T124/avm2/intrinsics/memory/package.html#si32()
            case Bytecode.SI8:
            case Bytecode.SI16:
            case Bytecode.SI32:
            case Bytecode.SF32:
            case Bytecode.SF64:
                ins = (new Instruction(oldi, z, [], -2));
                break;
            //http://docs.redtamarin.com/0.4.1T124/avm2/intrinsics/memory/package.html#li32()
            case Bytecode.LI8:
            case Bytecode.LI16:
            case Bytecode.LI32:
            case Bytecode.LF32:
            case Bytecode.LF64:
                ins = (new Instruction(oldi, z, [], 0));
                ins.returnTypeId = lastType = -3 /* NUMBER */;
                break;
            default: return { value: {
                    error: {
                        message: "UNKNOWN BYTECODE " + code[i - 1].toString(16) + " " + BytecodeName[code[i - 1]] + " at " + oldi,
                        reason: "unknow_bytecode" /* UNKNOW_BYTECODE */,
                    }
                } };
        }
        q.push(ins);
        out_i_1 = i;
    };
    var j, j, j, j, j, j, j, j, j, j, offset, cases, table, j, index, dyn, d, index, dyn, d, argnum, argnum, index, dyn, d, argnum, index, dyn, d, argnum, index, dyn, d, argnum, argnum, index, dyn, d, index, dyn, d, argnum, argnum, argnum, index, dyn, d, argnum, index, dyn, d, argnum, index, dyn, d, argnum, index, dyn, d, index, dyn, d, index, dyn, d, index, dyn, d, index, dyn, d, index, dyn, d, index, dyn, d, out_i_1;
    for (var i = 0; i < code.length;) {
        var state_1 = _loop_1(i);
        i = out_i_1;
        if (typeof state_1 === "object")
            return state_1.value;
    }
    var minStack = propagateStack(0, 0, q);
    propagateScope(0, 0, q);
    var jumps = [0];
    for (var i = 0; i < q.length; i++) {
        for (var j_2 = 0; j_2 < q[i].refs.length; j_2++) {
            jumps.push(q[i].refs[j_2]);
        }
    }
    var catchStart;
    var catchEnd;
    if (body.catchBlocks.length) {
        // collect try-catch blocks sorted by their start-position
        catchStart = {};
        // collect try-catch blocks sorted by their end-position
        catchEnd = {};
        for (var i = 0; i < body.catchBlocks.length; i++) {
            var block = body.catchBlocks[i];
            var stack = 0;
            var start = -1;
            var end = -1;
            var scope = 0;
            for (var c = 0; c < q.length; c++) {
                var pos = q[c].position;
                if (pos > block.start) {
                    start = pos;
                    break;
                }
                // propogade it
                stack = q[c].stack;
                scope = q[c].scope;
            }
            for (var c = q.length - 1; c >= 0; c--) {
                var pos = q[c].position;
                if (pos <= block.end) {
                    end = pos;
                    break;
                }
            }
            if (!catchStart[start])
                catchStart[start] = [];
            catchStart[start].push(block);
            if (!catchEnd[end])
                catchEnd[end] = [];
            catchEnd[end].push(block);
            // make sure that the target-instruction for the catch is propagated and set as target
            // using the stack value of the start-instruction does seem to do the trick
            // and this broadcast bug, if breakpoints is exist
            // IMPORTANT! Catch block push error on top of stack
            // this is why stack should start from 1 instead of 0
            var s = propagateStack(block.target, stack + 1, q);
            if (s < minStack)
                minStack = s;
            // IMPORTANT! SCOPE SHOULD BE PROPOGADED TOO
            propagateScope(block.target, scope, q);
            jumps.push(block.target);
        }
    }
    propogateTree(q, jumps);
    var error = minStack < 0 ? {
        message: 'Stack underrun while preprocess, stack:' + minStack,
        reason: "underrun" /* UNDERRUN */
    } : null;
    return {
        set: q,
        jumps: jumps,
        catchStart: catchStart,
        catchEnd: catchEnd,
        error: error
    };
}
